import { VERIFY_PAYMENT_START } from './constants'

export const verifyPaymentStart = (params) => ({ type: VERIFY_PAYMENT_START, data: { ...params } })
